import axiosIns from "@/api/axios";

export const GET_LIST = (params) => {
    return axiosIns.get("/e-mustering");
};

export const DETAIL = (id) => {
    return axiosIns.get(`/e-mustering/${id}`);
};

export const CREATE = (payload) => {
    return axiosIns.post("/e-mustering", payload);
};

export const UPDATE = (args) => {
    return axiosIns.put(`/e-mustering/${args.id}`, args);
};

export const DELETE = (id) => {
    return axiosIns.delete(`/e-mustering/${id}`);
};

export const SEND = (id) => {
    return axiosIns.put(`/e-mustering/send/${id}`);
};